import { render } from "./LeadTable.vue?vue&type=template&id=5d09abc2&scoped=true"
import script from "./LeadTable.vue?vue&type=script&lang=js"
export * from "./LeadTable.vue?vue&type=script&lang=js"

import "./LeadTable.vue?vue&type=style&index=0&id=5d09abc2&scoped=true&lang=css"

import exportComponent from "/home/travelcrm/travel-crm-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d09abc2"]])

export default __exports__